<div class="theme-item" [style.background-color]="theme().layout_page.background_color">
  @if (isDefaultTheme()) {
    <app-badge color="primary" backgroundColor="transparent"> DEFAULT </app-badge>
  }

  <div class="cover" [class.no-design]="!theme().cover.design">
    <app-cover-design [gallery]="gallery()" [theme]="theme()" [noAsset]="true"></app-cover-design>
    <div class="title" [appApplyTypographyStyles]="[theme().cover.title_typography]">Aa</div>
  </div>

  <div class="text">
    <div class="headings" [appApplyTypographyStyles]="[theme().section.title_typography]">
      {{ customTheme().name }}
    </div>
    <div class="paragraph" [appApplyTypographyStyles]="[theme().section.paragraph_typography]">
      This is your paragraph.
    </div>
  </div>

  <div class="cta" [class.dark]="theme().layout_page.background_color | isDarkColor">
    <app-context-menu [options]="{ noSpacing: true }" #menu>
      <button
        appButton
        name="context"
        location="custom-theme-item"
        color="hard-simple"
        height="1"
        [iconButton]="true"
        contextButton
      >
        <app-svg src="/assets/icons/dots-vertical.svg"></app-svg>
      </button>

      <div class="button-menu" contextContent>
        <app-button-menu-item
          name="rename"
          location="custom-theme-item"
          color="simple"
          [fullWidth]="true"
          (click)="renameTheme(); menu.close()"
          >Rename Theme
        </app-button-menu-item>
        @if (isTeamMember()) {
          <app-button-menu-item
            name="set-as-default"
            location="custom-theme-item"
            color="simple"
            [fullWidth]="true"
            (click)="setAsDefault(); menu.close()"
            [disabled]="isDefaultTheme()"
            >Set as Default
          </app-button-menu-item>
        }
        <div class="divider"></div>
        <app-button-menu-item
          name="delete"
          location="custom-theme-item"
          color="simple-warn"
          [fullWidth]="true"
          (click)="deleteTheme(); menu.close()"
          >Delete
        </app-button-menu-item>
      </div>
    </app-context-menu>
  </div>
</div>
